export default __webpack_public_path__ + "static/media/link.67bd4ec6.png";